import React from "react";

const map = {
    Critical: "sev-critical",
    Major: "sev-major",
    Minor: "sev-minor",
    Observation: "sev-observation",
};

export const SeverityChip = ({ value }) => {
    const cls = map[value] || "sev-observation";
    return (
        <span
            data-testid={`severity-${(value || "").toLowerCase()}`}
            className={`mono inline-flex items-center px-2 py-[3px] text-[11px] uppercase tracking-wider border rounded-sm ${cls}`}
        >
            {value || "—"}
        </span>
    );
};

const verdictMap = {
    PASS: "verdict-pass",
    CONDITIONAL: "verdict-conditional",
    FAIL: "verdict-fail",
    MISSING: "verdict-missing",
};

export const VerdictChip = ({ value }) => {
    const v = (value || "").toUpperCase();
    const cls = verdictMap[v] || "verdict-missing";
    return (
        <span
            data-testid={`verdict-${v.toLowerCase()}`}
            className={`mono inline-flex items-center px-2 py-[3px] text-[11px] tracking-wider border rounded-sm ${cls}`}
        >
            {v || "—"}
        </span>
    );
};

const statusMap = {
    Validated: "verdict-pass",
    "Validated with Conditions": "verdict-conditional",
    "Due for Review": "sev-minor",
    Overdue: "sev-critical",
    "Not Validated": "verdict-missing",
};

export const StatusBadge = ({ value }) => {
    const cls = statusMap[value] || "verdict-missing";
    return (
        <span
            data-testid={`status-badge`}
            className={`mono inline-flex items-center px-2 py-[3px] text-[11px] tracking-wider border rounded-sm ${cls}`}
        >
            {value || "—"}
        </span>
    );
};
